export default __webpack_public_path__ + "static/media/smoove.140074b6.png";